import { STATIC_DATA_STATES } from '../chart-components'
import {
    RawActivityEvent,
    RestrictedPipeMovement,
    RestrictedConnection,
    RestrictedRateOfPenetration,
    Uom
} from '../../utils/type'

export interface ActivityErrors {
    run_id: boolean
    end: boolean
    finalMD: boolean
    materialType: boolean
    restrictedConnections: boolean
    restrictedPipeMovements: boolean
    restrictedRops: boolean
    startMD: boolean
    oD: boolean
    tubularType: boolean
    connectionType: boolean
    start: boolean
}

export interface RestrictedPipeErrors {
    restrictedPipeMovementType: boolean
    restrictedPipeMovementSpeed: boolean
    restrictedPipeMovementSpeedAcronym: boolean
    startMD: boolean
    finalMD: boolean
    start: boolean
    end: boolean
}

export interface RestrictedConnectionErrors {
    restrictionType: boolean
    restrictedTimeConnection: boolean
    startMD: boolean
    finalMD: boolean
    start: boolean
    end: boolean
}
export interface RestrictedRateOfPenetrationErrors {
    restrictedRopType: boolean
    restrictedRopSpeed: boolean
    startMD: boolean
    finalMD: boolean
    start: boolean
    end: boolean
}
export interface Errors {
    activity: ActivityErrors
    restrictedPipe: RestrictedPipeErrors
    restrictedConnection: RestrictedConnectionErrors
    restrictedRateOfPenetration: RestrictedRateOfPenetrationErrors
    messages: { activity: string; restrictedPerformance: string }
}

export const emptyActivityErrors: ActivityErrors = {
    end: false,
    finalMD: false,
    materialType: false,
    restrictedConnections: false,
    restrictedPipeMovements: false,
    restrictedRops: false,
    run_id: false,
    start: false,
    startMD: false,
    oD: false,
    tubularType: false,
    connectionType: false
}

export const emptyRestrictedPipeErrors: RestrictedPipeErrors = {
    restrictedPipeMovementType: false,
    restrictedPipeMovementSpeed: false,
    restrictedPipeMovementSpeedAcronym: false,
    startMD: false,
    finalMD: false,
    start: false,
    end: false
}

export const emptyRestrictedConnectionErrors: RestrictedConnectionErrors = {
    restrictionType: false,
    restrictedTimeConnection: false,
    startMD: false,
    finalMD: false,
    start: false,
    end: false
}

export const emptyRestrictedRateOfPenetrationErrors: RestrictedRateOfPenetrationErrors = {
    restrictedRopType: false,
    restrictedRopSpeed: false,
    startMD: false,
    finalMD: false,
    start: false,
    end: false
}

export const getEmptyErrors = (): Errors => ({
    activity: { ...emptyActivityErrors },
    restrictedPipe: { ...emptyRestrictedPipeErrors },
    restrictedConnection: { ...emptyRestrictedConnectionErrors },
    restrictedRateOfPenetration: { ...emptyRestrictedRateOfPenetrationErrors },
    messages: { activity: '', restrictedPerformance: '' }
})

export const emptyRawActivityEvent: RawActivityEvent = {
    id: null,
    run_id: null,
    end: null,
    finalMD: { value: null, uom: null },
    materialType: null,
    thirdPartyResponsible: null,
    restrictedConnections: null,
    restrictedPipeMovements: null,
    restrictedRops: null,
    startMD: { value: null, uom: null },
    state: STATIC_DATA_STATES.EMPTY,
    oD: { value: null, uom: null },
    tubularType: null,
    connectionType: null,
    start: null
}

export const getEmptyRawRestrictedPipeEvent = (defaultUom: Uom | null = null): RestrictedPipeMovement => {
    return {
        id: null,
        tubularType_id: null,
        restrictedPipeMovementType: null,
        restrictedPipeMovementSpeed: { value: null, uom: null },
        restrictedPipeMovementSpeedAcronym: '',
        startMD: { value: null, uom: defaultUom },
        finalMD: { value: null, uom: defaultUom },
        start: null,
        end: null
    }
}

export const getEmptyRawRestrictedConnectionEvent = (defaultUom: Uom | null = null): RestrictedConnection => {
    return {
        id: null,
        tubularType_id: null,
        restrictionType: null,
        restrictedTimeConnection: { value: null, uom: null },
        restrictedTimeConnectionAcronym: '',
        startMD: { value: null, uom: defaultUom },
        finalMD: { value: null, uom: defaultUom },
        start: null,
        end: null
    }
}

export const getEmptyRawRestrictedRateOfPenetrationEvent = (
    defaultUom: Uom | null = null
): RestrictedRateOfPenetration => {
    return {
        id: null,
        tubularType_id: null,
        restrictedRopType: null,
        restrictedRopSpeed: { value: null, uom: null },
        restrictedRopSpeedAcronym: '',
        startMD: { value: null, uom: defaultUom },
        finalMD: { value: null, uom: defaultUom },
        start: null,
        end: null
    }
}
